/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { BaseResponse, MultiBaseResponse } from 'api/types';
import { useMemo, useState } from 'react';

import { useKeycloak } from '../utils/keycloakProvider';

const serverOrigin = process.env.REACT_APP_SERVER_ORIGIN;

const gatewayPort = process.env.REACT_APP_API_GATEWAY_PORT;

const gatewayBasePath = process.env.REACT_APP_API_BASE_PATH;

export const apiUrl = `${serverOrigin}${
  process.env.NODE_ENV.includes('development') &&
  gatewayPort &&
  gatewayPort !== ''
    ? ':'
    : ''
}${
  process.env.NODE_ENV.includes('development') &&
  gatewayPort &&
  gatewayPort !== ''
    ? gatewayPort
    : ''
}${gatewayBasePath}`;

export const useAxios = (): AxiosInstance => {
  const { keycloak } = useKeycloak();

  const instance = useMemo(() => {
    return axios.create({
      baseURL: apiUrl,
      responseType: 'json',
      headers: { Authorization: `Bearer ${keycloak.token}` },
    });
  }, [keycloak, keycloak.token]);

  instance.interceptors.response.use(
    async (response) => {
      if (response.data?.result) {
        const res = response as AxiosResponse<BaseResponse<any>>;
        res.data = res.data.result;
        return res;
      }

      if (response.data && response.data.results && !response.data.totalPages) {
        const res = response as AxiosResponse<MultiBaseResponse<any>>;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        res.data = res.data.results;
        return res;
      }

      if (response.data === '') {
        response.data = null;
        return response;
      }

      return response;
    },
    (error) => {
      const err = error as AxiosError<any>;

      if (err.response) {
        err.response.data = err.response.request.response.message;
      }

      return Promise.reject(err);
    }
  );

  return instance;
};

export const useAxiosPdf = (): AxiosInstance => {
  const { keycloak } = useKeycloak();
  const instance = useMemo(() => {
    return axios.create({
      baseURL: apiUrl,
      responseType: 'blob',
      headers: { Authorization: `Bearer ${keycloak.token}` },
    });
  }, [keycloak, keycloak.token]);

  instance.interceptors.response.use(
    async (response) => {
      if (response.data?.result) {
        const res = response as AxiosResponse<BaseResponse<any>>;
        res.data = res.data.result;
        return res;
      }
      if (response.data && response.data.results && !response.data.totalPages) {
        const res = response as AxiosResponse<MultiBaseResponse<any>>;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        res.data = res.data.results;
        return res;
      }
      if (response.data === '') {
        response.data = null;
        return response;
      }
      return response;
    },
    (error) => {
      const err = error as AxiosError<any>;

      if (err.response) {
        err.response.data = err.response.request.response.message;
      }
      return Promise.reject(err);
    }
  );

  return instance;
};

export const useAxiosForNotLogged = (): AxiosInstance => {
  const instance = useMemo(() => {
    const axiosInstance = axios.create({
      baseURL: apiUrl,
      responseType: 'json',
    });

    axiosInstance.interceptors.response.use(
      async (response) => {
        if (response.data?.result) {
          const res = response as AxiosResponse<BaseResponse<any>>;
          res.data = res.data.result;
          return res;
        }

        if (
          response.data &&
          response.data.results &&
          !response.data.totalPages
        ) {
          const res = response as AxiosResponse<MultiBaseResponse<any>>;
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          res.data = res.data.results;
          return res;
        }
        if (response.data === '') {
          response.data = null;
          return response;
        }

        return response;
      },
      (error) => {
        const err = error as AxiosError<any>;

        if (err.response) {
          err.response.data = err.response.request.response.message;
        }

        return Promise.reject(err);
      }
    );

    return axiosInstance;
  }, []);

  return instance;
};
export const useAxiosPdfForNotLogged = (): AxiosInstance => {
  const instance = useMemo(() => {
    return axios.create({
      baseURL: apiUrl,
      responseType: 'blob',
    });
  }, []);

  instance.interceptors.response.use(
    async (response) => {
      if (response.data?.result) {
        const res = response as AxiosResponse<BaseResponse<any>>;
        res.data = res.data.result;
        return res;
      }
      if (response.data && response.data.results && !response.data.totalPages) {
        const res = response as AxiosResponse<MultiBaseResponse<any>>;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        res.data = res.data.results;
        return res;
      }
      if (response.data === '') {
        response.data = null;
        return response;
      }
      return response;
    },
    (error) => {
      const err = error as AxiosError<any>;

      if (err.response) {
        err.response.data = err.response.request.response.message;
      }
      return Promise.reject(err);
    }
  );

  return instance;
};
